import {callApi} from '@/api/api-core'

export const GetRecycleApiKeys = function(){
    return callApi('GET', 'api/recycleapikeys/get', null)
}